// Catálogo de "formas" visuales — independiente de la paleta de colores.
// Define cómo se ven las tarjetas y botones (radio de bordes, sombra,
// borde, y si la lista de docentes se ve en cuadrícula o en filas tipo
// lista). No cambia ningún dato ni lógica, solo la presentación.

const catalogoEstilos = [
  {
    key: "clasico",
    nombre: "Clásico",
    descripcion: "Tarjetas en cuadrícula con foto grande, sombra suave y botones redondeados — el diseño actual.",
    shell: "topbar",
    tieneInicio: false,
    layoutDocentes: "grid",
    layoutServicios: "grid",
    cardRadius: 18,
    cardShadow: "0 10px 28px rgba(0,0,0,0.08)",
    cardBorder: "none",
    botonRadius: 12,
    botonEstilo: "solido",
    fotoTamano: 115,
    calendarView: "dayGridWeek",
    horariosLista: false,
    horariosGridLateral: false,
    horariosConfirmar: false,
    formDosColumnas: false,
    misCitasTabs: false,
  },
  {
    key: "lista_compacta",
    nombre: "Lista Compacta",
    descripcion: "Los docentes se ven en una lista de filas (foto pequeña + nombre + botón), como una agenda profesional.",
    shell: "topbar",
    tieneInicio: false,
    layoutDocentes: "lista",
    layoutServicios: "grid",
    cardRadius: 12,
    cardShadow: "0 2px 8px rgba(0,0,0,0.06)",
    cardBorder: "1px solid rgba(0,0,0,0.06)",
    botonRadius: 8,
    botonEstilo: "solido",
    fotoTamano: 56,
    calendarView: "dayGridWeek",
    horariosLista: false,
    horariosGridLateral: false,
    horariosConfirmar: false,
    formDosColumnas: false,
    misCitasTabs: false,
  },
  {
    key: "minimalista",
    nombre: "Minimalista",
    descripcion: "Tarjetas planas sin sombra, bordes finos y botones tipo contorno — look limpio y moderno.",
    shell: "topbar",
    tieneInicio: false,
    layoutDocentes: "grid",
    layoutServicios: "grid",
    cardRadius: 8,
    cardShadow: "none",
    cardBorder: "1px solid rgba(0,0,0,0.12)",
    botonRadius: 6,
    botonEstilo: "outline",
    fotoTamano: 100,
    calendarView: "dayGridWeek",
    horariosLista: false,
    horariosGridLateral: false,
    horariosConfirmar: false,
    formDosColumnas: false,
    misCitasTabs: false,
  },
  {
    key: "moderno",
    nombre: "Moderno (tipo app de reservas)",
    descripcion:
      "Servicios y docentes en lista, calendario en vista de semana por defecto (el padre puede cambiar a mes si quiere), horarios en lista vertical, y pestañas en Mis Citas — inspirado en apps de reservas profesionales.",
    shell: "topbar",
    tieneInicio: false,
    layoutDocentes: "lista",
    layoutServicios: "lista",
    cardRadius: 14,
    cardShadow: "0 4px 14px rgba(0,0,0,0.07)",
    cardBorder: "1px solid rgba(0,0,0,0.06)",
    botonRadius: 10,
    botonEstilo: "solido",
    fotoTamano: 48,
    calendarView: "dayGridWeek",
    horariosLista: true,
    horariosGridLateral: false,
    horariosConfirmar: false,
    formDosColumnas: false,
    misCitasTabs: true,
  },
  {
    key: "portal_lateral",
    nombre: "Portal Lateral",
    descripcion:
      "Menú fijo a la izquierda (Inicio, Mis citas, Nueva cita, Ayuda) con pantalla de bienvenida, servicios en tarjetas grandes, calendario y horarios lado a lado con botón \"Continuar\", y confirmación de cita en dos columnas.",
    shell: "sidebar",
    tieneInicio: true,
    layoutDocentes: "lista",
    layoutServicios: "tarjetas_iconos",
    cardRadius: 14,
    cardShadow: "0 2px 10px rgba(0,0,0,0.06)",
    cardBorder: "1px solid rgba(0,0,0,0.08)",
    botonRadius: 10,
    botonEstilo: "solido",
    fotoTamano: 48,
    calendarView: "dayGridWeek",
    horariosLista: false,
    horariosGridLateral: true,
    horariosConfirmar: true,
    formDosColumnas: true,
    misCitasTabs: true,
  },
];

export const ESTILO_POR_DEFECTO = catalogoEstilos[0];

export const obtenerEstilo = (key) =>
  catalogoEstilos.find((e) => e.key === key) || ESTILO_POR_DEFECTO;

export default catalogoEstilos;
